export const getFormLabelText = (label: string, isFieldRequired?: boolean): string => {
    return isFieldRequired ? `${label}*` : label;
};
